import { http, HttpResponse } from 'msw';

/** This is used for Vitest tests */
export const localhostHandlers = [
  // src/helpers/fetchAppVersion.spec.ts
  http.get(`*/fetchAppVersion`, ({ request }) => {
    const url = new URL(request.url);
    return HttpResponse.text(url.searchParams.get('version') ?? '', {
      status: 200,
    });
  }),
];
